export default {
  label: {
    id: 'merchant_options_payment_payout_status_rejected',
    defaultMessage: 'There is an error with your KYB information.',
  },
}
